import { render, staticRenderFns } from "./AppBarBadgeButton.vue?vue&type=template&id=0c38e64b"
import script from "./AppBarBadgeButton.vue?vue&type=script&lang=js"
export * from "./AppBarBadgeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports